import { ASCI_CHARACTERS } from "../react-components/constants/artworks";

export function isThreeMeshUIValidInput(input) {
  const allowedChars = ASCI_CHARACTERS;
  for (let i = 0; i < input.length; i++) {
    if (!allowedChars.includes(input[i])) {
      return false; // Invalid character found
    }
  }
  return true; // All characters are valid
}

export const isYearValid = value => {
  const year = parseInt(value, 10);
  return /^\d{1,4}$/.test(value) && year > 0;
};
